import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup  } from '@angular/forms';
import { JProject } from '@ascschool/interface/project';
import { ButtonType } from '@ascschool/interface/setting';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTableFilterFn, NzTableFilterList, NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { AddStudentComponent } from './popup/add-student/add-student.component';
import { DeleteStudentComponent } from './popup/delete-student/delete-student.component';

interface DataItem {
  numberIndex: number;
  code: string;
  firstName: string;
  lastName: string;
  gender: string;
  dob: string;
  yoa: number;
  class: string;
}
interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn | null;
  listOfFilter: NzTableFilterList | null;
  filterFn: NzTableFilterFn | null;
  filterMultiple: boolean;
  sortDirections: NzTableSortOrder[];
}
@Component({
  selector: 'app-sample8',
  templateUrl: './sample8.component.html',
  styleUrls: ['./sample8.component.scss']
})
export class Sample8Component implements OnInit, AfterViewInit {
  get breadcrumbs(): string[] {
    return ['THPT', 'Học sinh'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageExpandedSearch', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageExpandedSearch = content;
    }
  }
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  btnType : ButtonType;
  constructor(private msg: NzMessageService,
              private fb: FormBuilder,
              private cdRef: ChangeDetectorRef,
              public _authService: AuthService,
              public sizePageService: SizePageService,
              private modalService: NzModalService,
              private authQuery: AuthQuery,
) {}
  width: number;
  viewHeight: number;
  numberControl: number;
  private elementPageExpandedSearch: ElementRef;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageSample8', { static: false }) elementPageSample8: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  buttonTypeEnum = ButtonType;
  height: number ;
  heightPopup: number;
  contentHeight: number;
  heightPagnagation: number = 50;
  heightContentPaddingtop: number = 16;
  heightContentPaddingbottom: number = 16;
  columns: any;
  divisibleForFour: boolean;
  rows: any;
  editId: string | null = null;
  validateForm!: FormGroup;
  project: JProject;
  controlArray: Array<{ index: number; show: boolean }> = [];
  isCollapse = true;
  shortcuts: ShortcutInput[] = [];
  // tslint:disable-next-line: member-ordering
  listOfEmployeeFilter = [
    { text: 'Employee', value: true },
    { text: 'not Employee', value: false }
  ];
  listOfData: DataItem[] = [
    {
      numberIndex: 1,
      code: '1900177326',
      firstName: 'Dương Thị Thùy',
      lastName: 'Anh',
      gender: 'Nữ',
      dob: '2004-11-30',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 2,
      code: '1900177327',
      firstName: 'Ngô Phương',
      lastName: 'Anh',
      gender: 'Nữ',
      dob: '2004-10-25',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 3,
      code: '1900177328',
      firstName: 'Tống Duy',
      lastName: 'Anh',
      gender: 'Nam',
      dob: '2004-02-26',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 4,
      code: '1900177332',
      firstName: 'Bùi Xuân',
      lastName: 'Đảm',
      gender: 'Nam',
      dob: '2004-09-13',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 5,
      code: '1900177333',
      firstName: 'Hoàng Ngọc',
      lastName: 'Đạt',
      gender: 'Nam',
      dob: '2004-10-10',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 6,
      code: '1900177334',
      firstName: 'Ngô Duy',
      lastName: 'Đông',
      gender: 'Nam',
      dob: '2004-06-01',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 7,
      code: '1900177329',
      firstName: 'Lê Đăng',
      lastName: 'Dũng',
      gender: 'Nam',
      dob: '2004-01-16',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 8,
      code: '1900177330',
      firstName: 'Nguyễn Trọng',
      lastName: 'Dũng',
      gender: 'Nam',
      dob: '2004-11-18',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 9,
      code: '1900177331',
      firstName: 'Ngô Thị',
      lastName: 'Duyên',
      gender: 'Nữ',
      dob: '2004-09-26',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 10,
      code: '1900177335',
      firstName: 'Nguyễn Thị Hương',
      lastName: 'Giang',
      gender: 'Nữ',
      dob: '2004-06-20',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 11,
      code: '1900177336',
      firstName: 'Dương Thị Khánh',
      lastName: 'Hà',
      gender: 'Nữ',
      dob: '2004-06-13',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 12,
      code: '1900177337',
      firstName: 'Giáp Thị Ngân',
      lastName: 'Hà',
      gender: 'Nữ',
      dob: '2004-04-23',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 13,
      code: '1900177338',
      firstName: 'Nguyễn Thị Vân',
      lastName: 'Hà',
      gender: 'Nữ',
      dob: '2004-11-08',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 14,
      code: '1900177339',
      firstName: 'Vũ Văn',
      lastName: 'Hải',
      gender: 'Nam',
      dob: '2004-07-24',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 15,
      code: '1900177340',
      firstName: 'Ngô Trung',
      lastName: 'Hiếu',
      gender: 'Nam',
      dob: '2004-08-09',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 16,
      code: '1900177341',
      firstName: 'Nguyễn Trung',
      lastName: 'Hiếu',
      gender: 'Nam',
      dob: '2004-11-13',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 17,
      code: '1900177343',
      firstName: 'Nguyễn Mai',
      lastName: 'Hương',
      gender: 'Nữ',
      dob: '2004-01-10',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 18,
      code: '1900177342',
      firstName: 'Đỗ Ngọc',
      lastName: 'Huyền',
      gender: 'Nữ',
      dob: '2004-01-27',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 19,
      code: '1900177344',
      firstName: 'Nguyễn Thanh',
      lastName: 'Kiên',
      gender: 'Nam',
      dob: '2004-03-10',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 20,
      code: '1900177345',
      firstName: 'Nguyễn Trung',
      lastName: 'Kiên',
      gender: 'Nam',
      dob: '2004-03-23',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 21,
      code: '1900177346',
      firstName: 'Nguyễn Thị Khánh',
      lastName: 'Linh',
      gender: 'Nữ',
      dob: '2004-10-17',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 22,
      code: '1900177347',
      firstName: 'Trần Hoàng Bảo',
      lastName: 'Long',
      gender: 'Nam',
      dob: '2004-08-06',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 23,
      code: '1900177348',
      firstName: 'Lưu Văn',
      lastName: 'Minh',
      gender: 'Nam',
      dob: '2004-04-26',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 24,
      code: '1900177349',
      firstName: 'Nguyễn Quang',
      lastName: 'Minh',
      gender: 'Nam',
      dob: '2004-10-12',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 25,
      code: '1900177350',
      firstName: 'Nguyễn Trà',
      lastName: 'My',
      gender: 'Nữ',
      dob: '2004-07-02',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 26,
      code: '1900177351',
      firstName: 'Nguyễn Phương',
      lastName: 'Nguyên',
      gender: 'Nữ',
      dob: '2004-11-08',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 27,
      code: '1900177352',
      firstName: 'Nguyễn Thị Thu',
      lastName: 'Nguyệt',
      gender: 'Nữ',
      dob: '2004-08-30',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 28,
      code: '1900177353',
      firstName: 'Nguyễn Minh',
      lastName: 'Phú',
      gender: 'Nam',
      dob: '2004-09-23',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 29,
      code: '1900177354',
      firstName: 'Ngô Thành',
      lastName: 'Phúc',
      gender: 'Nam',
      dob: '2004-11-12',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 30,
      code: '1900177355',
      firstName: 'Nguyễn Khánh',
      lastName: 'Quyền',
      gender: 'Nam',
      dob: '2004-07-18',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 31,
      code: '1900177356',
      firstName: 'Nguyễn Thị Diễm',
      lastName: 'Quỳnh',
      gender: 'Nữ',
      dob: '2004-06-15',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 32,
      code: '1900177357',
      firstName: 'Nguyễn Ngọc',
      lastName: 'Sơn',
      gender: 'Nam',
      dob: '2004-01-11',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 33,
      code: '1900177358',
      firstName: 'Đỗ Tiến',
      lastName: 'Tài',
      gender: 'Nam',
      dob: '2004-12-15',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 34,
      code: '1900177360',
      firstName: 'Nguyễn Đức',
      lastName: 'Thắng',
      gender: 'Nam',
      dob: '2004-06-04',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 35,
      code: '1900177359',
      firstName: 'Nguyễn Công',
      lastName: 'Thành',
      gender: 'Nam',
      dob: '2004-06-21',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 36,
      code: '1900177361',
      firstName: 'Nguyễn Ngọc',
      lastName: 'Tiến',
      gender: 'Nam',
      dob: '2004-05-23',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 37,
      code: '1900177362',
      firstName: 'Nguyễn Văn Chí',
      lastName: 'Tôn',
      gender: 'Nam',
      dob: '2004-02-19',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 38,
      code: '1900177363',
      firstName: 'Nghiêm Xuân',
      lastName: 'Vinh',
      gender: 'Nam',
      dob: '2004-05-05',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 39,
      code: '1900177364',
      firstName: 'Nguyễn Văn',
      lastName: 'Vũ',
      gender: 'Nam',
      dob: '2004-04-01',
      yoa: 2000,
      class: '10a2'
    },
    {
      numberIndex: 40,
      code: '1900177365',
      firstName: 'Bùi Minh',
      lastName: 'Vương',
      gender: 'Nam',
      dob: '2004-03-02',
      yoa: 2000,
      class: '10a2'
    }
  ];
  sortNameFn = (a: DataItem, b: DataItem) => a.lastName.localeCompare(b.lastName);
  ngOnInit() {
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe(item => {
      this.checkCaculateHeight(this.isCollapse);
    } );
    this.authQuery.userSetting$.subscribe(type => {
      if (type){
        this.btnType = type.btnType;
      }
    });
    this.validateForm = this.fb.group({
      quanHuyen: [null],
      maHs: [null],
      hoTen: [null],
      gioiTinh: [null],
      ngaySinh: [null],
      danToc: [null],
      dienChinhSach: [null],
      khuyetTat: [null],
      diaChi: [null],
      namNhapHoc: [null],
      daXepLop: [null],
      lopHoc: [null],
    });

    this.numberControl = Object.keys(this.validateForm.value).length;
    if (this.isCollapse){
      this.divisibleForFour = this.isDivisibleForFour(4);
    }else{
      this.divisibleForFour = this.isDivisibleForFour(this.numberControl);
    }
  }
  ngAfterViewInit(){
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
    this.cdRef.detectChanges();
    // keyboard
    this.shortcuts.push({
      key: ["alt + n"],
      label: "Help",
      description: "Cmd + b",
      command: (e) => this.showAddStudent(),
      preventDefault: true
    });
  }
  isDivisibleForFour(index: number){
    if (index % 4 === 0){
      return true;
    }else{
      return false;
    }
  }
  checkCaculateHeight(isOpen: boolean){
    // if (isOpen === true) {
    // //   setTimeout(() => {
    // //     console.log( this.heightfnc(), this.elementPageExpandedSearch.nativeElement.offsetHeight);
    // //     this.height = this.heightfnc() - this.elementPageExpandedSearch.nativeElement.offsetHeight;
    // //     this.width = this.widthfnc();
    // //   }, 1);
    // // } else {
    // //   setTimeout(() => {
    // //     this.height = this.heightfnc();
    // //     this.width = this.widthfnc();
    // //   }, 1);
    // }
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    });
  }
  heightfnc(){
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation,
      this.heightContentPaddingtop,
      this.heightContentPaddingbottom);
  }
  widthfnc(){
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize(){
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  submitForm(): void {
    // tslint:disable-next-line: forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }
  startEdit(id: string): void {
    this.editId = id;
  }
  stopEdit(): void {
    this.editId = null;
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void {
    this.validateForm.reset();
  }
  onChange(result: Date[]): void {
    console.log('onChange: ', result);
  }
  //popup
  showAddStudent(): void {
    this.modalService.create({
      nzTitle: 'Thông tin hồ sơ học sinh',
      nzContent: AddStudentComponent,
      nzStyle: { top: '20px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzWidth: 1500
    });
  }
  showDeleteStudent(): void {
    this.modalService.create({
      nzTitle: 'Xóa thông tin học sinh',
      nzContent: DeleteStudentComponent,
      // nzComponentParams: {
      //   heightBody: this.caculateHeightPopup(this.maxHeight)
      // },
      nzStyle: { top: '20px' },
      nzMaskClosable: false,
    });
  }
}
